export default "__VITE_ASSET__D6Qztm$0__"